<div class="spinner-wrapper">
    <div>
        <img src="/assets/spinner.gif" class="spinner"/>
    </div>
</div>